// src/utils/tracking.js
// Centralized conversion + analytics tracking for ad optimization.
//
// Fires Google Ads conversions (AW-18021533667), GA4 events (G-MTZP2WPR87),
// and Meta Pixel events (only when a Meta pixel is present on the page).
//
// Every parent-contact action — lead form submit, click-to-call, click-to-
// WhatsApp — is tracked so Google Ads and Meta smart bidding have enough
// conversion signal to optimize. Previously only the form submit was tracked,
// which starved smart bidding (≈1 conversion total => it was bidding blind).

const GOOGLE_ADS_ID = 'AW-18021533667';

// Google Ads conversion labels (the part after "AW-XXXX/").
// `lead` is the existing, already-verified admission-form action. Calls and
// WhatsApp clicks reuse it for now so they immediately count as conversions in
// the live account with zero extra setup. To report them as *separate* actions,
// create dedicated conversion actions in Google Ads and paste their labels into
// `call` / `whatsapp` below.
const ADS_LABELS = {
    lead: 'vP89CMf94KccEOOPq5FD',
    call: 'vP89CMf94KccEOOPq5FD',
    whatsapp: 'vP89CMf94KccEOOPq5FD',
};

function gtagEvent(name, params = {}) {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('event', name, params);
    }
}

function adsConversion(label) {
    if (!label) return;
    gtagEvent('conversion', {
        send_to: `${GOOGLE_ADS_ID}/${label}`,
        value: 1.0,
        currency: 'INR',
    });
}

function metaEvent(name, params = {}) {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq('track', name, params);
    }
}

// Admission / lead form submission — the primary conversion.
export function trackLead(meta = {}) {
    gtagEvent('generate_lead', { currency: 'INR', value: 1.0, ...meta });
    adsConversion(ADS_LABELS.lead);
    metaEvent('Lead', meta);
}

// Click-to-call (tel: links).
export function trackCallClick(meta = {}) {
    gtagEvent('contact_call', { method: 'phone', ...meta });
    adsConversion(ADS_LABELS.call);
    metaEvent('Contact', { method: 'phone', ...meta });
}

// Click-to-WhatsApp (wa.me links).
export function trackWhatsAppClick(meta = {}) {
    gtagEvent('contact_whatsapp', { method: 'whatsapp', ...meta });
    adsConversion(ADS_LABELS.whatsapp);
    metaEvent('Contact', { method: 'whatsapp', ...meta });
}
